import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';

interface ComputeButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const ComputeButton: React.FC<ComputeButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
}) => {
  return (

    <Box display="flex" justifyContent="center" alignItems="center">
      <Button
        variant="contained"
        color="success"
        onClick={onClick}
        disabled={disabled || loading}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          bgcolor: 'success.main',
          color: '#fff',
          width: 120,
          height: 40,
          boxShadow: 4, 
          '&:hover': { bgcolor: 'success.dark', boxShadow: 4 },
          '&.Mui-disabled': {
            bgcolor: 'action.disabledBackground',
            color: 'action.disabled',
            boxShadow: 'none', 
          },
        }}
        aria-label="Run compute"
      >
        {loading ? (<CircularProgress size={28} color="inherit" />) : (<ChevronRightIcon sx={{ fontSize: 28 }} />)}
      </Button>
    </Box>
  );
};

export default React.memo(ComputeButton);
